import React from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import { PersonalCertificateResultV2 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { personalCertificateApi } from '../../../httpclient';
import {
  IOwnCertificateContext,
  OwnCertificateContext,
} from '../../../services/contexts/OwnCertificateContext';
import { asLoadable } from '../../../types';

export const OwnCertificateProvider: React.FC<{ children: any }> = ({ children }) => {
  const {
    result,
    errorObject,
    loading,
    callApi: loadOwnCertificates,
  } = useApi({
    apiFunction: () =>
      personalCertificateApi.v2PersonalcertificateGetownpersonalcertificatesv2Get(),
    callApiOnInit: true,
  });

  const value: IOwnCertificateContext = {
    ownCertificates: asLoadable<PersonalCertificateResultV2[]>(result, errorObject, loading),
    refresh: loadOwnCertificates,
  };

  return <OwnCertificateContext.Provider value={value}>{children}</OwnCertificateContext.Provider>;
};
